import { createContext, useContext, type ReactNode } from 'react';
import type { LabsReviewApi } from './types';

export interface LabsReviewModule {
  api: LabsReviewApi;
  getErrorMessage(error: unknown): string;
}

const LabsReviewContext = createContext<LabsReviewModule | null>(null);

export function LabsReviewProvider({ module, children }: { module: LabsReviewModule; children: ReactNode }) {
  return <LabsReviewContext.Provider value={module}>{children}</LabsReviewContext.Provider>;
}

export function useLabsReview(): LabsReviewModule {
  const module = useContext(LabsReviewContext);
  if (!module) throw new Error('Labs review views must be rendered inside LabsReviewProvider');
  return module;
}
